/* global femcare */

femcare.form.validationInitialization = {
    init() {
        const $forms = $('.validate-form');

        $forms.each((_, form) => {
            this.initFormValidation($(form));
        });
    },

    initFormValidation($form) {
        const $inputs = $form.find('[data-validate]');

        $inputs.on('input', function () {
            $(this).validate();
        });

        $inputs.filter('[data-match]').each((_, input) => {
            const $input = $(input);
            const rawValue = $input.attr('data-match');

            if (!rawValue || rawValue === '#') {
                return;
            }

            const id = rawValue.replace(/^#/, '');
            if (!id) {
                return;
            }

            const $matchingInput = $('#' + CSS.escape(id));
            if ($matchingInput.length) {
                $matchingInput.on('input', () => $input.validate());
            }
        });
    }
};
